import React from 'react'
import _ from "lodash"
import classnames from "classnames"
import {useSelector} from 'react-redux'
//************************************//
import InputContainer from "@src/components/helpers/InputContainer"
//************************************//

const GlobalListSelect = props => {
//************************************//
  const {useForm, name = "", defaultValue = null, rules = {}} = props
  const {control, errors, trigger, register, setValue } = useForm
//************************************//
//************************************//
  const globalList = useSelector(store => store.resources.data.global_list)
  const globalListOptions = _.map(globalList, x => ({label: x.name, value: x.uuid, id: x.id}))
//************************************//
  const getDefaultValue = () => {
    if (_.isString(defaultValue)) {
      return _.find(globalListOptions, x => defaultValue === x.value)
    }
    return ''
  }
//************************************//
  return (
    <InputContainer
      control={control}
      type='select'
      options={globalListOptions}
      name={name}
      defaultValue={getDefaultValue()}
      classNamePrefix={'select'}
      className={classnames('react-select', {'is-invalid':_.get(errors, name)})}
      rules={rules}
    />
  )
}

GlobalListSelect.propTypes = {

}

export default GlobalListSelect
